export default "__VITE_PUBLIC_ASSET__7b0a381f__"